<div class="icon-wrapper" [innerHTML]="svgContent" [class.disabled]="disabled"></div>
